import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { ControlUser } from './controlUser';
import { DateHelper } from '../util/dateHelper';
import { parse } from 'date-fns';


export class AccessLog extends BaseModel implements Deserializable {

  id: number;
  userUid: string;
  user: ControlUser;
  state: string;
  date: Date;
  deviceSerial: number;
  accessName: string;
  userOwnerName: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    this.user = new ControlUser().deserialize(this.user);
    this.date = parse(input.date); // 2021-11-19T06:39:54.000Z
    return this;
  }

  isGranted() {

    return "Granted" == this.state;
  }

  getDateFriendly() {
    return DateHelper.formatDateFriendly(this.date);
  }

  getTimeFriendly() {
    return DateHelper.formatTimeFriendly(this.date);
  }

}
